export default {
  'pages.layouts.userLayout.title': 'EnderRealm Console - 一站式管理平台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码(admin/ant.design)',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '用户名: admin or user',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '密码: ant.design',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.welcome.title': '欢迎使用 EnderRealm Console',
  'pages.welcome.description':
    'EnderRealm Console 是一站式管理后台，集成了职员管理、服内管理、负载均衡等功能。一站式的设计让您无需在多个系统间切换，提高工作效率。通过侧边栏可快速访问各功能模块。',
  'pages.welcome.advantage.unified.title': '统一管理',
  'pages.welcome.advantage.unified.desc':
    '所有管理功能集中在一个平台，无需在多个系统间切换，大幅提升工作效率。',
  'pages.welcome.advantage.efficient.title': '高效便捷',
  'pages.welcome.advantage.efficient.desc':
    '简化操作流程，减少重复登录和数据同步，让管理工作更加流畅。',
  'pages.welcome.advantage.secure.title': '安全可靠',
  'pages.welcome.advantage.secure.desc':
    '统一的权限管理和安全策略，确保数据安全和访问控制的一致性。',
  'pages.welcome.advantage.scalable.title': '灵活扩展',
  'pages.welcome.advantage.scalable.desc':
    '模块化设计支持功能扩展，可根据业务需求灵活添加新的管理模块。',
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  // 工具页面
  'pages.tools.title': '实用工具',
  'pages.tools.bedrockPackCrypto.title': '基岩版资源包加密',
  'pages.tools.bedrockPackCrypto.description': '为基岩版资源包提供加密功能，保护您的创作内容',
  'pages.tools.mcTextFormatter.title': 'MC文本格式化',
  'pages.tools.expCurve.title': '经验曲线工具',
};
